
/*!
 * @pixelunion/pxs-header-standard v2.0.0
 * (c) 2023 Pixel Union
 */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var EventHandler_1 = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
var EventHandler = /** @class */ (function () {
    function EventHandler() {
        this.events = [];
    }
    EventHandler.prototype.register = function (el, event, listener) {
        if (!el || !event || !listener)
            return null;
        this.events.push({ el: el, event: event, listener: listener });
        el.addEventListener(event, listener);
        return { el: el, event: event, listener: listener };
    };
    EventHandler.prototype.unregister = function (_a) {
        var el = _a.el, event = _a.event, listener = _a.listener;
        if (!el || !event || !listener)
            return null;
        this.events = this.events.filter(function (e) { return el !== e.el
            || event !== e.event || listener !== e.listener; });
        el.removeEventListener(event, listener);
        return { el: el, event: event, listener: listener };
    };
    EventHandler.prototype.unregisterAll = function () {
        this.events.forEach(function (_a) {
            var el = _a.el, event = _a.event, listener = _a.listener;
            return el.removeEventListener(event, listener);
        });
        this.events = [];
    };
    return EventHandler;
}());
exports["default"] = EventHandler;
});

var EventHandler = unwrapExports(EventHandler_1);

/*!
   * @pixelunion/animations v0.1.0
   * (c) 2019 Pixel Union
   * Released under the UNLICENSED license.
  */

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

/**
 * Promisified version of window.requestAnimationFrame.
 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
 */
function raf() {
  return new Promise(function (resolve) {
    window.requestAnimationFrame(resolve);
  });
}
/**
 * Represents an HTML element with associate states
 */


var Animation =
/*#__PURE__*/
function () {
  /**
   * @param {Object} options
   * @param {HTMLElement}  options.el Target element
   * @param {String} [options.state=initial] Initial state. This is also the default state.
   * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
   * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
   * update with change of state.
   * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
   * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
   * next state change.
   * @param {Function} [options.onStart] Callback to execute immediate after
   * applying stateChangeAttribute.
   */
  function Animation(options) {
    _classCallCheck$1(this, Animation);

    this._el = options.el;
    this.cancelRunning = null;
    this._state = options.state || 'initial';
    this.initialState = this._state;
    this.stateAttribute = options.stateAttribute || 'data-animation-state';
    this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
    this.endEvent = options.endEvent || 'transitionend';
    this.hold = !!options.hold;

    this.onStart = options.onStart || function () {
      /* do nothing */
    };

    this.activeEventHandler = null;
  }
  /**
   * Returns target element
   *
   * @return {HTMLElement} Target element
   */


  _createClass$1(Animation, [{
    key: "isState",

    /**
     * Check if a state is active
     * @param {String} state State to compare
     *
     * @return {Boolean}
     */
    value: function isState(state) {
      return state === this._state;
    }
    /**
     * Sequences a change to a new state.
     * @param {String} state Target state
     *
     * @param {Boolean} options.force Switch to final state immediately
     *
     * @param {Function} options.onStart Callback to execute immediately after
     * applying stateChangeAttribute for this state change only.
     *
     * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
     * next state change.
     *
     * @return {Promise} Resolves when endEvent triggered
     */

  }, {
    key: "animateTo",
    value: function animateTo(state) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var from = this._el.dataset[this.stateAttribute] || this._state;
      var to = state || this.initialState;
      var force = options.force;
      var hold = 'hold' in options ? options.hold : this.hold;
      return new Promise(function (resolve) {
        if (_this.cancelRunning) {
          _this.cancelRunning();
        }

        if (from === to) {
          // Removing this here fixes some lingering attributes. But why?
          _this._el.removeAttribute(_this.stateChangeAttribute);

          resolve(from, null);
          return;
        }

        var running = true;

        _this.cancelRunning = function () {
          running = false;
          resolve(null, null);
        };

        _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

        _this.activeEventHandler = null;

        if (force) {
          _this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

          _this.onStart({
            el: _this._el,
            from: from,
            to: to
          });

          if (typeof options.onStart === 'function') {
            options.onStart({
              el: _this._el,
              from: from,
              to: to
            });
          }

          _this._el.setAttribute(_this.stateAttribute, to);

          _this._state = to;

          if (!hold) {
            _this._el.removeAttribute(_this.stateChangeAttribute);
          }

          resolve(to, null);
          return;
        }

        raf().then(function () {
          if (!running) throw new Error('cancelled');

          _this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

          _this.onStart({
            el: _this._el,
            from: from,
            to: to
          });

          if (typeof options.onStart === 'function') {
            options.onStart({
              el: _this._el,
              from: from,
              to: to
            });
          }

          return raf();
        }).then(function () {
          if (!running) throw new Error('cancelled');

          _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

          _this.activeEventHandler = function (e) {
            // Ignore any events bubbling up
            if (e.target !== _this._el || !running) return;

            _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

            if (!hold) {
              _this._el.removeAttribute(_this.stateChangeAttribute);
            }

            resolve(to, e);
          };

          _this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

          _this._el.setAttribute(_this.stateAttribute, to);

          _this._state = to;
        })["catch"](function (error) {
          // Only catch 'cancelled' errors.
          if (error.message !== 'cancelled') throw error;
        });
      });
    }
    /**
     * Remove any event listeners
     */

  }, {
    key: "unload",
    value: function unload() {
      this._el.removeEventListener(this.endEvent, this.activeEventHandler);

      this.activeEventHandler = null;
    }
  }, {
    key: "el",
    get: function get() {
      return this._el;
    }
    /**
     * Returns current state
     *
     * @return {String} Current state
     */

  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
  }]);

  return Animation;
}();

function transition(options) {
  return new Animation(options);
}

var HeaderNavParent = /*#__PURE__*/function () {
  function HeaderNavParent(options) {
    var _this = this;

    _classCallCheck(this, HeaderNavParent);

    this.menuItem = options.menuItem;
    this.detailsItem = options.menuItem.querySelector('[data-header-nav-details]');
    this.parentMenu = options.parentMenu;
    this.menuLink = this.detailsItem.querySelector('[data-header-nav-link]');
    this.submenuEl = this.menuItem.querySelector('[data-header-nav-submenu]');
    this._isOpen = false;
    this.submenu = null;
    this.events = new EventHandler();
    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
    this.close = this.close.bind(this); // When a user hits the escape key all of the menus should close and the keyboard focus should return
    // to the parent link. This will bubble up to the top parent menu.

    this.closeEsc = function (e) {
      if (e.key === 'Escape') {
        _this.menuLink.focus();

        _this._close();
      }
    }; // When the mouse leaves the open menu, we don't want to close it right away. Setting a delay on close
    // allows situations where you might go to another parent menu but your mouse would drag slightly outside
    // of the open menu, causing you to have to go back and open the menu again. This improves accessibility
    // as well as general usability.


    this.closeTimer = null;

    this.mouseover = function () {
      clearTimeout(_this.closeTimer);

      _this._open();
    };

    this.mouseout = function () {
      _this.closeTimer = setTimeout(_this.close, 400);
    };

    this.click = function (e) {
      e.stopPropagation(); // If the menu is already open, we want to continue to the link in the <a> tag.
      // For mouse hover, this is pretty straightforward, but with keyboard and touch navigation
      // you will have to touch or trigger that link a second time. This is maybe not the best for
      // accessibility, but it's a good compromise for now.

      var clickedParent = e.target.closest('[data-header-nav-link]');

      if (clickedParent && clickedParent.dataset.href) {
        // We only prevent the click through if the menu wasn't already open.
        e.preventDefault();

        if (_this._isOpen) {
          window.location = clickedParent.dataset.href;
          return;
        }
      } // If the submenu isn't open, open it


      _this._open();
    }; // During keyboard navigation, when you focus onto the parent menuItem, this will close the other
    // menu items that were previously open. This usually happens when you were navigating within
    // a submenu and then tab out of it to the next menu item at a lower tier.


    this.focusin = function (e) {
      e.stopPropagation();

      _this.parentMenu.closeSiblings(_this);
    }; // Set up animation event


    this.animation = transition({
      el: this.submenuEl,
      state: 'closed'
    });
    this.events.register(this.menuItem, 'mouseover', function () {
      return _this.mouseover();
    });
    this.events.register(this.menuItem, 'mouseout', function () {
      return _this.mouseout();
    });
    this.events.register(this.menuItem, 'click', function (e) {
      return _this.click(e);
    });
    this.events.register(this.menuItem, 'touchend', function (e) {
      return _this.click(e);
    });
    this.events.register(this.menuItem, 'focusin', function (e) {
      return _this.focusin(e);
    }); // If the user clicks, taps, or their keyboard focus reaches outside of the menu
    // we should close this menu.

    this.events.register(document.body, 'click', function () {
      return _this._close();
    });
    this.events.register(document.body, 'focusin', function () {
      return _this._close();
    });
  }

  _createClass(HeaderNavParent, [{
    key: "forceOpen",
    value: function forceOpen() {
      return this._open();
    }
  }, {
    key: "forceClose",
    value: function forceClose() {
      return this._close();
    }
  }, {
    key: "close",
    value: function close() {
      this._close();
    }
  }, {
    key: "_open",
    value: function _open() {
      var _this2 = this;

      if (this._isOpen) return;
      this._isOpen = true;
      this.parentMenu.closeSiblings(this);
      this.closeEscEvent = this.events.register(window, 'keydown', function (e) {
        return _this2.closeEsc(e);
      });

      if (!this.submenu) {
        this.submenu = new HeaderNavMenu({
          navList: this.submenuEl
        });
      }

      this.submenuEl.classList.remove('alternate-drop');
      this.animation.animateTo('open', {
        onStart: function onStart(_ref) {
          var el = _ref.el;
          // Check to see if dropdown is offscreen and apply a class so it can be styled differently.
          var menuBounds = el.getBoundingClientRect();

          if (menuBounds.right > document.documentElement.clientWidth) {
            el.classList.add('alternate-drop');
          }

          if (menuBounds.left < 0) {
            el.classList.add('alternate-drop-left');
          }
        }
      });
      this.menuLink.setAttribute('aria-expanded', true);
      this.detailsItem.setAttribute('open', 'open');
    }
  }, {
    key: "_close",
    value: function _close() {
      var _this3 = this;

      if (!this._isOpen) return;

      if (this.submenu) {
        this.submenu.unload();
        this.submenu = null;
      }

      this._isOpen = false;
      this.events.unregister(this.closeEscEvent);
      this.animation.animateTo('closed').then(function () {
        _this3.submenuEl.classList.remove('alternate-drop');

        _this3.menuLink.setAttribute('aria-expanded', false);

        _this3.detailsItem.removeAttribute('open');
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.forceClose();
      this.events.unregisterAll();

      if (this.closeEscEvent) {
        this.events.unregister(this.closeEscEvent);
      }
    }
  }]);

  return HeaderNavParent;
}();

var HeaderNavMenu = /*#__PURE__*/function () {
  function HeaderNavMenu(options) {
    var _this = this;

    _classCallCheck(this, HeaderNavMenu);

    this.navList = options.navList;
    this.menuItems = this.navList.children;
    this.parents = [];
    this.events = new EventHandler();

    for (var i = 0; i < this.menuItems.length; i++) {
      var menuItem = this.menuItems[i];

      if (menuItem.dataset.headerNavParent !== undefined) {
        this.parents.push(new HeaderNavParent({
          menuItem: menuItem,
          parentMenu: this
        }));
      } else {
        // If the keyboard navigation moves to another menuItem, we should close any
        // other existing menus that are open.
        this.events.register(menuItem, 'focusin', function () {
          return _this.closeAllMenus();
        });
      }
    }
  } // This function will close all menus that are not the current menu.
  // This is mostly used by the HeaderNavParent class.


  _createClass(HeaderNavMenu, [{
    key: "closeSiblings",
    value: function closeSiblings(current) {
      this.parents.forEach(function (parent) {
        if (parent !== current) {
          parent.close();
        }
      });
    }
  }, {
    key: "closeAllMenus",
    value: function closeAllMenus() {
      this.parents.forEach(function (parent) {
        return parent.close();
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.parents.forEach(function (parent) {
        parent.unload();
      });
      this.events.unregisterAll();
    }
  }]);

  return HeaderNavMenu;
}();

// It is a separate class so that we can initialize it on its own with different headers.

var HeaderNav = /*#__PURE__*/function () {
  function HeaderNav(options) {
    _classCallCheck(this, HeaderNav);

    this.header = options.header;
    this.navTier1 = this.header.querySelector('[data-header-nav-tier-1]');

    if (this.navTier1) {
      this.headerNavMenu = new HeaderNavMenu({
        navList: this.navTier1
      });
    }
  }

  _createClass(HeaderNav, [{
    key: "unload",
    value: function unload() {
      if (this.headerNavMenu) {
        this.headerNavMenu.unload();
      }
    }
  }]);

  return HeaderNav;
}();

var HeaderStandard = /*#__PURE__*/function () {
  function HeaderStandard(section) {
    var _this = this;

    _classCallCheck(this, HeaderStandard);

    this.el = section.el;
    this.data = section.data;
    this.sticky = this.data.sticky;
    this.transparent = this.data.transparent;
    this.events = new EventHandler();
    this.header = this.el.querySelector('[data-site-header]');
    this.headerLogo = this.el.querySelector('[data-header-logo]');
    this.logoImage = this.el.querySelector('[data-logo-image]');
    this.logoImageTransparent = this.el.querySelector('[data-logo-image-transparent]');
    this.logoImageMobile = this.el.querySelector('[data-logo-image-mobile]');
    this.cartCount = this.el.querySelector('[data-cart-count]');
    this.scrollObserver = null;
    this.scrollObserverPoint = this.el.querySelector('[data-header-scroll-observer]'); // We need to place the scroll observer point to be outside of the header within the body tag.

    document.body.appendChild(this.scrollObserverPoint);
    this._setTransparency = this._setTransparency.bind(this);
    this.events.register(window, 'resize', function () {
      return _this._recordSizeVariables();
    });
    this.events.register(this.header, 'rimg:load', function () {
      return _this._recordSizeVariables();
    });
    this.events.register(document, 'cart:count', function (e) {
      return _this._updateCartCount(e);
    }); // In the editor, listen for events when another section is moved (in case it is first)

    this.events.register(window, 'shopify:section:reorder', function () {
      return _this._initTransparency();
    });

    this._initTransparency();

    this._recordSizeVariables();

    this.headerNav = new HeaderNav({
      header: this.header
    });
  }

  _createClass(HeaderStandard, [{
    key: "_recordSizeVariables",
    value: function _recordSizeVariables() {
      this._recordHeaderHeight();

      this._recordLogoWidth();
    }
  }, {
    key: "_recordHeaderHeight",
    value: function _recordHeaderHeight() {
      document.body.style.setProperty('--header-height', "".concat(this.header.offsetHeight, "px"));
    }
  }, {
    key: "_recordLogoWidth",
    value: function _recordLogoWidth() {
      // If the image exists and is visible, record its width in a CSS variable.
      if (this.logoImage && this.logoImage.offsetParent) {
        this.header.style.setProperty('--logo-width', "".concat(this.logoImage.getBoundingClientRect().width, "px"));
      } else if (this.logoImageTransparent && this.logoImageTransparent.offsetParent) {
        this.header.style.setProperty('--logo-width', "".concat(this.logoImageTransparent.getBoundingClientRect().width, "px"));
      } else if (this.logoImageMobile && this.logoImageMobile.offsetParent) {
        this.header.style.setProperty('--logo-width', "".concat(this.logoImageMobile.getBoundingClientRect().width, "px"));
      } else {
        this.header.style.setProperty('--logo-width', "".concat(this.headerLogo.getBoundingClientRect().width, "px"));
      }
    }
  }, {
    key: "_initTransparency",
    value: function _initTransparency() {
      var _this2 = this;

      document.body.removeAttribute('data-transparent-header'); // We only want to change transparency if the header is sticky
      // and if the first section is a banner.

      if (this.firstSectionIsBanner()) {
        if (this.sticky && this.transparent) {
          document.body.dataset.transparentHeader = true;
          this.scrollObserver = new IntersectionObserver(function (entries) {
            return _this2._setTransparency(entries);
          });
          this.scrollObserver.observe(this.scrollObserverPoint);
        } else if (this.transparent) {
          document.body.dataset.transparentHeader = true;
        }
      }
    }
  }, {
    key: "_setTransparency",
    value: function _setTransparency(entries) {
      if (!entries) {
        return;
      }

      if (entries[0].isIntersecting || !this.sticky) {
        document.body.dataset.transparentHeader = true;
      } else {
        document.body.dataset.transparentHeader = false;
      }

      this._recordHeaderHeight();
    }
  }, {
    key: "_updateCartCount",
    value: function _updateCartCount(e) {
      var count = e.detail.count;
      this.cartCount.innerHTML = count;
    }
  }, {
    key: "firstSectionIsBanner",
    value: function firstSectionIsBanner() {
      var firstSection = document.querySelector('main section');
      return firstSection && firstSection.dataset.banner === 'true';
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.headerNav.unload();
      this.events.unregisterAll();

      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
      }

      document.body.removeAttribute('data-transparent-header');
    }
  }]);

  return HeaderStandard;
}();

export default HeaderStandard;
